import Type from 'src/Type';
import config from 'src/utils/config';

import Node from '../Node';

import type Context from 'src/Context';

export interface CancelSiblingsNodeT {
    $type: 'CancelSiblingsNode';
}

export default class CancelSiblingsNode extends Node<CancelSiblingsNodeT> {
    static TYPE = Type.Object();

    static uiConfig = {
        ...config.presets.tasker,
        description: "Cancel this task's unfinished sibling tasks (same parent task)",
    };

    async execute(context: Context): Promise<void> {
        context.addTaskerAction({ kind: 'cancelSiblings' });
    }
}
